var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 24.6668C19.8909 24.6668 24.6666 19.8912 24.6666 14.0002C24.6666 8.10914 19.8909 3.3335 13.9999 3.3335C8.1089 3.3335 3.33325 8.10914 3.33325 14.0002C3.33325 19.8912 8.1089 24.6668 13.9999 24.6668Z",
    fill: "url(#paint0_radial_1414_3954)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.9999 24.6668C19.8909 24.6668 24.6666 19.8912 24.6666 14.0002C24.6666 8.10914 19.8909 3.3335 13.9999 3.3335C8.1089 3.3335 3.33325 8.10914 3.33325 14.0002C3.33325 19.8912 8.1089 24.6668 13.9999 24.6668Z",
    fill: "url(#paint1_radial_1414_3954)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1802 10.2463C12.2936 9.83301 11.9136 9.45298 11.1469 9.24634C10.4935 9.07298 8.96687 9.04631 7.6402 10.053C7.39355 10.2397 7.6402 10.4397 7.86021 10.3397C8.60686 9.98634 10.4069 9.75965 11.6402 10.2397C12.1335 10.433 12.1802 10.2463 12.1802 10.2463Z",
    fill: "url(#paint2_linear_1414_3954)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5136 14.5735C11.0806 14.5735 11.5402 13.878 11.5402 13.0201C11.5402 12.1622 11.0806 11.4668 10.5136 11.4668C9.94659 11.4668 9.48694 12.1622 9.48694 13.0201C9.48694 13.878 9.94659 14.5735 10.5136 14.5735Z",
    fill: "url(#paint3_radial_1414_3954)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5136 11.9868C10.9536 11.9868 11.3403 12.3734 11.5402 12.9401C11.5269 12.1001 11.0736 11.4268 10.5136 11.4268C9.95359 11.4268 9.50027 12.1001 9.48694 12.9401C9.68693 12.3734 10.0736 11.9868 10.5136 11.9868Z",
    fill: "url(#paint4_linear_1414_3954)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52696 20.4266C9.61366 20.44 9.69363 20.4133 9.75366 20.36C10.8403 19.3999 12.5203 18.88 13.7803 18.88H14.0003H14.2203C15.4803 18.88 17.1603 19.3999 18.247 20.36C18.307 20.4133 18.3937 20.44 18.4736 20.4266C18.5603 20.4133 18.607 20.32 18.5603 20.2466C17.6336 18.7266 15.9137 17.7866 14.0537 17.7866H14.0003H13.947C12.0803 17.7866 10.367 18.7266 9.4403 20.2466C9.387 20.32 9.43365 20.4133 9.52696 20.4266Z",
    fill: "#643800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52673 20.4266C9.61343 20.4399 9.6934 20.4132 9.75343 20.3599C10.8401 19.3999 12.5201 18.8799 13.7801 18.8799H14.0001H14.2201C15.4801 18.8799 17.1601 19.3999 18.2467 20.3599C18.3068 20.4132 18.3934 20.4399 18.4734 20.4266C18.5601 20.4132 18.6067 20.3199 18.5601 20.2465C18.5534 20.2332 18.5401 20.2199 18.5334 20.1999C18.4468 20.2465 18.3534 20.2932 18.2534 20.1932C17.2201 19.0999 15.6934 18.4465 14.0534 18.4465H13.9934H13.9334C12.2868 18.4465 10.7468 19.1065 9.71342 20.2199C9.62008 20.3199 9.53342 20.2732 9.44676 20.2199C9.44007 20.2332 9.43342 20.2399 9.42673 20.2532C9.38673 20.3199 9.43342 20.4132 9.52673 20.4266Z",
    fill: "url(#paint5_linear_1414_3954)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8202 10.2463C15.7069 9.83301 16.0869 9.45298 16.8535 9.24634C17.5069 9.07298 19.0335 9.04631 20.3602 10.053C20.6069 10.2397 20.3602 10.4397 20.1402 10.3397C19.3936 9.98634 17.5935 9.75965 16.3602 10.2397C15.8669 10.433 15.8202 10.2463 15.8202 10.2463Z",
    fill: "url(#paint6_linear_1414_3954)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4801 14.5735C18.0471 14.5735 18.5067 13.878 18.5067 13.0201C18.5067 12.1622 18.0471 11.4668 17.4801 11.4668C16.913 11.4668 16.4534 12.1622 16.4534 13.0201C16.4534 13.878 16.913 14.5735 17.4801 14.5735Z",
    fill: "url(#paint7_radial_1414_3954)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4801 11.9868C17.92 11.9868 18.3067 12.3734 18.5067 12.9401C18.4934 12.1001 18.0401 11.4268 17.4801 11.4268C16.9201 11.4268 16.4667 12.1001 16.4534 12.9401C16.6534 12.3734 17.04 11.9868 17.4801 11.9868Z",
    fill: "url(#paint8_linear_1414_3954)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1414_3954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8986 9.67731) scale(12.868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1414_3954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8986 9.67731) scale(10.1238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1414_3954",
    x1: 9.64223,
    y1: 11.0226,
    x2: 10.1031,
    y2: 9.30265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1414_3954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.2082 13.0595) rotate(73.8539) scale(1.50712 0.975086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1414_3954",
    x1: 10.5151,
    y1: 11.4264,
    x2: 10.5151,
    y2: 12.9411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1414_3954",
    x1: 13.9975,
    y1: 17.8929,
    x2: 13.9975,
    y2: 19.3864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1414_3954",
    x1: 18.3391,
    y1: 11.0639,
    x2: 17.8783,
    y2: 9.34395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1414_3954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1732 13.0596) rotate(73.8539) scale(1.50712 0.975086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1414_3954",
    x1: 17.48,
    y1: 11.4264,
    x2: 17.48,
    y2: 12.9411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpset);
export default __webpack_public_path__ + "static/media/Upset.a4962c0bcfd90e5fc1694fc5d677da55.svg";
export { ForwardRef as ReactComponent };